import { useIsMobile } from '#pplx/frontend/platform-components/useMobileStyle.js';
import { useMemo } from 'react';
export function useIsMobileForBuild(options = {}) {
    const { isMobileStyle: _isMobileStyle, isMobileUserAgent } = useIsMobile();
    const { isSidecarBuild = import.meta.env.VITE_IS_SIDECAR_BUILD, isEmbeddedSidecarBuild = import.meta.env.VITE_IS_EMBEDDED_SIDECAR_BUILD, isInlineAssistantBuild = import.meta.env.VITE_IS_INLINE_ASSISTANT_BUILD, isComputerAppBuild = import.meta.env.VITE_IS_COMPUTER_APP_BUILD, } = options;
    return useMemo(() => ({
        isMobileStyle: 
        // Comet sidecar, embedded sidecar, inline assistant, and computer-app builds should never use mobile styling.
        // They are rendered within desktop apps where mobile styling is not desired
        // to ensure a consistent desktop-like experience.
        isSidecarBuild || isEmbeddedSidecarBuild || isInlineAssistantBuild || isComputerAppBuild
            ? false
            : // The user agent is a mobile device (i.e: iOS or Android)
                // or the current media query matches a mobile screen size (i.e: Tailwind's "md" breakpoint).
                _isMobileStyle,
        isMobileUserAgent,
    }), [
        _isMobileStyle,
        isMobileUserAgent,
        isSidecarBuild,
        isEmbeddedSidecarBuild,
        isInlineAssistantBuild,
        isComputerAppBuild,
    ]);
}
//# sourceMappingURL=useAetherMobileStyle.js.map